import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { patchUserSettings } from "../../store/user/actions"

const ReportingBreadcrumbTitle = ({ title }) => {
  const { user_settings: { dashboard_type }, user_settings_loading } = useSelector(state => state.User)
  const dispatch = useDispatch()

  const isDefault = () => {
    switch (dashboard_type) {
      case "quality_non_cohort_report":
        return title.toLowerCase() === "QUALITY REPORT".toLowerCase()
      case "quality_cohort_report":
        return title.toLowerCase() === "QUALITY COHORT REPORT".toLowerCase()
      case "top_management_report":
        return title.toLowerCase() === "TOP MANAGEMENT REPORT".toLowerCase()
      default:
        return false
    }
  }

  const getPageKey = () => {
    switch (title.toLowerCase()) {
      case "QUALITY REPORT".toLowerCase():
        return 'quality_non_cohort_report'
      case "QUALITY COHORT REPORT".toLowerCase():
        return 'quality_cohort_report'
      case "TOP MANAGEMENT REPORT".toLowerCase():
        return 'top_management_report'
      default:
        return false
    }
  }


  const getContent = () => {
    if (user_settings_loading) return (
      <div className="spinner-border text-primary" style={{width: 10, height: 10, borderWidth: 2}} role="status"><span className="sr-only">Loading...</span></div>
    )

    const onClick = () => {
      const pageKey = getPageKey()
      dispatch(patchUserSettings({dashboard_type: pageKey}))
    }

    if (isDefault()) {
      return <h6 className="m-0"><small className="text-muted">(Using as default)</small></h6>
    } else {
      return <h6 className="m-0 link-info" onClick={onClick}><small className="text-muted">(Set as default)</small></h6>
    }
  }

  return (
    <ReportingBreadcrumbTitleStyled>
      <div className="me-1">{title}</div>
      {getContent()}
    </ReportingBreadcrumbTitleStyled>
  )
}

ReportingBreadcrumbTitle.propTypes = {
  title: PropTypes.any
}

const ReportingBreadcrumbTitleStyled = styled.div`
  display: inline-flex;
  align-items: center;
  
  h6.link-info small{
    color: #50a5f1 !important;
    cursor: pointer;
  }
`

export default (ReportingBreadcrumbTitle)
